export async function configureTornamentBeforeRecord(data) {
  if (data.city) {
    data.city = `/cities/${data.city.id}`
  }
  if (data.cities) {
    data.city = `/cities/${data.cities.id}`
  }

  return data
}

export async function configureTornamentBeforeUpdate(data) {
  if (data.city) {
    data.city = `/cities/${data.city.id}`
  }

  return data
}
